<template>
  <div class="footerBox">
    <div class="content">
      <img class="bottomImgInfo" src="https://htmlqiniu.jihex.com/bottomBannerNewText.png" alt="">
      <div class="companyTitle">
        <div class="leftText">杭州恰途科技有限公司 2019 @ All Rights Reserved</div>
        <div style="margin-left:10px;" @click="goICP" class="rightText">{{providerText}}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      providerText:'',
    }
  },
  methods:{
    goICP() {
      window.open('http://www.beian.gov.cn/portal/recordQuery')
    }
  },
  mounted () {
    console.log(window.location)
    //备案号
    if(window.location.host=='jiheclub.cn'||window.location.host=='jiheclub.com'||window.location.host=='jihex.cn') {
      this.providerText='浙ICP备14041939号-2'
    }else if(window.location.host=='jihelife.com') {
      this.providerText = '浙ICP备14041939号-1'
    }else if(window.location.host=='www.jihex.com') {
      this.providerText = '浙ICP备20015274号-1'
    }else if(window.location.host=='www.jihex.com') {
      this.providerText = '浙ICP备20015274号-1'
    }else if(window.location.host=='www.timesaas.cn') {
      this.providerText = '浙ICP备14041939号-3'
    }else if(window.location.host=='timesaas.vip') {
      this.providerText = '浙ICP备14041939号-4'
    }
  }
}
</script>
<style lang="scss" scoped>
.footerBox {
  width: 100%;
  min-width: 1200px;
  height: 240px;
  background: url(https://htmlqiniu.jihex.com/bottomBannerNew.png);
  background-repeat: no-repeat;
  background-position:center center;
  background-size: cover;
  position: relative;
  .content {
    width: 1200px;
    box-sizing: border-box;
    margin: 0 auto;
    .bottomImgInfo {
      width: 1200px;
      height: 160px;
    }
    .companyTitle {
      color: #868B8F;
      line-height: 12px;
      font-size: 12px;
      display: flex;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 40px;
      .leftText {
        border-right: 1px solid #606266;
        padding-right: 10px;
        line-height: 12px;
      }
    }
  }
}
.rightText {
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/navTop/footer.vue